import type { StepContent } from './step-ui';
import type { SequenceMap } from './systems';

export interface ParsedSteps {
  steps: StepContent[];
  sequenceMap: SequenceMap;
}

export function parseSteps(xml: string): ParsedSteps {
  const parser = new DOMParser();
  const doc = parser.parseFromString(xml, 'text/html');

  const stepElements = doc.querySelectorAll('div.step');
  const steps: StepContent[] = [];
  const sequenceMap: SequenceMap = {};

  stepElements.forEach((stepEl, index) => {
    const title = stepEl.getAttribute('data-title') ?? '';
    const description = stepEl.getAttribute('data-description') ?? '';
    steps.push({ title, description });

    const sequences = stepEl.getElementsByTagName('sequence');
    if (sequences.length >= 1) {
      const forwardName = sequences[0].getAttribute('name');
      if (forwardName) {
        sequenceMap[`${index - 1}-${index}`] = forwardName;
      }
    }
    if (sequences.length >= 2) {
      const reverseName = sequences[1].getAttribute('name');
      if (reverseName) {
        sequenceMap[`${index}-${index - 1}`] = reverseName;
      }
    }
  });

  return { steps, sequenceMap };
}
